import { render } from "./EmployeeLiquidation.vue?vue&type=template&id=b277e06a"
import script from "./EmployeeLiquidation.vue?vue&type=script&lang=js"
export * from "./EmployeeLiquidation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__